import { createSelector } from 'reselect';

const filterTimeCarousel = {
  open: {
    '00:01:00': 180000,
    '00:05:00': 900000,
    '00:15:00': 2700000,
    '01:00:00': 10800000,
    '1.00:00:00': 259200000,
  },
  closed: {
    '00:01:00': -240000,
    '00:05:00': -1200000,
    '00:15:00': -35000000,
    '01:00:00': -14400000,
    '1.00:00:00': -259200000,
  },
};

export const contestsFromRoot = (state:any) => state.contestSeries;


export const getStatusFetched = (state:any) => state.contestSeries.series.isFetched;

export const getContestsStore = createSelector(
  (state:any) => contestsFromRoot(state),
  (contestSeries) => {
    const seriesKey = `${"00:01:00"}-${"USDC"}-${"BTC"}`;
    const contestsDisplay = (contestSeries.series[seriesKey] || [])
      .map((contestId:string) => {
        const contest = contestSeries.contests[contestId];
        return contest;
      })
      .filter((contest:any) => {
        if (!contest) {
          return false;
        }
        const timeFromLive = Date.parse(contest.contestLiveTime) - Date.now();

        if (contest.status !== 'Closed') {
          return timeFromLive < filterTimeCarousel.open["00:01:00"];
        } else {
          return timeFromLive > filterTimeCarousel.closed["00:01:00"];
        }
      })
      .sort((a:any, b:any) => {
        const aTime:any = new Date(a.contestLiveTime);
        const bTime:any = new Date(b.contestLiveTime);

        if (b.status === 'GoingLive' && (a.status === 'Live' || a.status === 'Opened')) {
          return 1;
        }
        if (b.status === 'Live' && a.status === 'Opened') {
          return 1;
        }
        if (a.status && b.status === 'Live') {
          const aTime :any = new Date(a.contestCloseTime);
          const bTime :any = new Date(b.contestCloseTime);
          return aTime - bTime;
        }
        return aTime - bTime;
      });

    return contestsDisplay;
  }
);